import React, { useEffect, useState } from "react";
import { DataGrid, getGridStringOperators } from "@mui/x-data-grid";
import {
    Select, Tab, Tabs, MenuItem, InputLabel, FormControl,
    Autocomplete, FormControlLabel, Paper, Dialog, DialogTitle,
    DialogContent, DialogActions, Chip, Divider, Collapse
} from "@mui/material";
import { Grid, Card, CardContent } from "@mui/material";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import TuneIcon from '@mui/icons-material/Tune';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CloseIcon from '@mui/icons-material/Close';
import styled from "styled-components";
import {
    Typography, Button, Checkbox, IconButton,
    InputAdornment, TextField, Stack, Box
} from "@mui/material";
import { useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import { TABS, ROLES } from "../../constants";

const OLYMPIAD_MODULE_ID = "RsRohirsRs";

const ADVANCED_KEYS = [
    { key: "addSo", label: "Add SO", description: "Allow adding Sales Orders", color: "#10b981" },
    { key: "verifySo", label: "Verify SO", description: "Allow verifying Sales Orders", color: "#3b82f6" },
    { key: "disputeSo", label: "Dispute SO", description: "Allow raising SO disputes", color: "#f59e0b" },

    // { key: "addInv", label: "Add Invoice", description: "Allow adding Invoices", color: "#10b981" },
    // { key: "verifyInv", label: "Verify Invoice", description: "Allow verifying Invoices", color: "#3b82f6" },
    // { key: "disputeInv", label: "Dispute Invoice", description: "Allow raising Invoice disputes", color: "#f59e0b" },
    { key: "addSmInv", label: "Add SM Invoice", description: "Allow adding SM Invoices", color: "#10b981" },
    { key: "addRcInv", label: "Add RC Invoice", description: "Allow adding RC Invoices", color: "#10b981" },
    { key: "verifySmInv", label: "Verify SM Invoice", description: "Allow verifying SM Invoices", color: "#3b82f6" },
    { key: "verifyRcInv", label: "Verify RC Invoice", description: "Allow verifying RC Invoices", color: "#3b82f6" },
    { key: "disputeSmInv", label: "Dispute SM Invoice", description: "Allow raising SM Invoice disputes", color: "#f59e0b" },
    { key: "disputeRcInv", label: "Dispute RC Invoice", description: "Allow raising RC Invoice disputes", color: "#f59e0b" },

    { key: "itemShipment", label: "Item Shipment", description: "Allow initiating item shipments", color: "#8b5cf6" },
    { key: "updateShipment", label: "Update Shipment", description: "Allow updating shipment details", color: "#06b6d4" },
    { key: "itemDeliver", label: "Item Deliver", description: "Allow marking items as delivered", color: "#ec4899" },

    { key: "verify", label: "Verify", description: "Allow marking items as verify", color: "#48deec" },
    { key: "onHold", label: "On Hold", description: "Allow marking items as on hold", color: "#ec485b" },
];

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile && ` position: relative; `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;
const TableContainer = styled.div`
  width: 100%;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};
  ${isMobile && `flex-direction: column;`}
`;
const TabsContainer = styled.div`
  ${isMobile && `height: calc(100vh - 56px - 20px - 43.77px);`}
`;

// ── Styled dialog internals ─────────────────────────────────────────────────
const ActionCard = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 10px;
  border: 2px solid ${({ enabled }) => enabled ? "#10b981" : "#e5e7eb"};
  background: ${({ enabled }) => enabled ? "linear-gradient(135deg,#f0fdf4,#dcfce7)" : "#fafafa"};
  cursor: pointer;
  transition: all 0.18s ease;
  user-select: none;
  &:hover {
    border-color: ${({ enabled }) => enabled ? "#059669" : "#9ca3af"};
    box-shadow: 0 2px 10px rgba(0,0,0,0.08);
    transform: translateY(-1px);
  }
`;
const GroupLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #6b7280;
  margin: 18px 0 8px;
`;

export default function AccessManagement() {
    const location = useLocation();
    const selectedTabProp1 = location.state?.selectedTabProp;

    const [loading, setLoading] = useState(false);
    const [rowCount, setRowCount] = useState();
    const [currentPage] = useState(1);
    const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 30 });
    const [hasSearched, setHasSearched] = useState(false);
    const [visibleEmployees, setVisibleEmployees] = useState([]);
    const [rm, setRm] = useState("");
    const [rsm, setRsm] = useState("");
    const [asm, setAsm] = useState("");
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [modules, setModules] = useState([]);
    const [module, setModule] = useState("");
    const [roles, setRoles] = useState([]);
    const [role, setRole] = useState("");
    const [userData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user);
    const [selectedTab, setSelectedTab] = useState(selectedTabProp1 || TABS.REGISTERED);
    const [newUser, setNewUser] = useState("");
    const [newAllUsers, setNewAllUsers] = useState([]);
    const [permissions, setPermissions] = useState({ is_add: "Yes", is_update: "Yes", is_delete: "Yes", is_download: "Yes", is_approve: "Yes" });
    const [modulesPermissions, setModulesPermissions] = useState([]);

    // ── Advanced dialog state ────────────────────────────────────────────────
    const [advDialogOpen, setAdvDialogOpen] = useState(false);
    const [advPermissions, setAdvPermissions] = useState({
        addSo: "No", verifySo: "No", disputeSo: "No",
        // addInv: "No", verifyInv: "No", disputeInv: "No",
        addSmInv: "No", addRcInv: "No",
        verifySmInv: "No", verifyRcInv: "No",
        disputeSmInv: "No", disputeRcInv: "No",
        itemShipment: "No", updateShipment: "No", itemDeliver: "No",
        verify: "No", onHold: "No",
    });
    const [advSaving, setAdvSaving] = useState(false);

    // ── helpers ──────────────────────────────────────────────────────────────
    const enabledAdvCount = Object.values(advPermissions).filter((v) => v === "Yes").length;

    const olympiadModulePermission = modulesPermissions.find((m) => m.moduleId === OLYMPIAD_MODULE_ID);

    // ── lifecycle ────────────────────────────────────────────────────────────
    useEffect(() => { fetchOrder(); }, [paginationModel.page, paginationModel.pageSize, module, newUser]);

    useEffect(() => {
        setNewUser("");
        const filtered = allUsers?.filter((us) => us?.role === "admin");
        setNewAllUsers(role === "" ? filtered : allUsers.filter((u) => u.role.toLowerCase() === "admin"));
    }, [role]);

    useEffect(() => {
        fetchRoles();
        if (userData?.role.toLowerCase().includes("admin")) getAllUsers();
    }, []);

    // sync advPermissions whenever the olympiad module row changes
    useEffect(() => {
        if (!olympiadModulePermission) return;
        const p = olympiadModulePermission.permissions;
        setAdvPermissions({
            addSo: p.addSo ?? "No",
            verifySo: p.verifySo ?? "No",
            disputeSo: p.disputeSo ?? "No",
            addSmInv: p.addSmInv ?? "No",
            addRcInv: p.addRcInv ?? "No",
            verifySmInv: p.verifySmInv ?? "No",
            verifyRcInv: p.verifyRcInv ?? "No",
            disputeSmInv: p.disputeSmInv ?? "No",
            disputeRcInv: p.disputeRcInv ?? "No",
            itemShipment: p.itemShipment ?? "No",
            updateShipment: p.updateShipment ?? "No",
            itemDeliver: p.itemDeliver ?? "No",
            verify: p.verify ?? "No",
            onHold: p.onHold ?? "No",
        });
    }, [olympiadModulePermission?.permissions]);

    // ── API calls ────────────────────────────────────────────────────────────
    const fetchRoles = async () => {
        try {
            setLoading(true);
            const results = await window.Platform.database.fetchRoles();
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
            } else {
                setModules(results?.moduleData?.results.filter((e) => e.status === 1) || []);
                const exc = results?.data.filter((r) => r.roleName.toLowerCase() !== "se");
                setRoles(exc.filter((e) => e.roleName === "admin"));
            }
        } catch (err) { console.log(err); }
        finally { setLoading(false); }
    };

    const fetchOrder = async () => {
        try {
            setLoading(true);
            const results = await window.Platform.database.fetchAccessModules({
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId: newUser,
                moduleId: module,
            });
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                return;
            }
            const withId = results?.data?.map((obj, i) => ({ ...obj, idIndex: i + 1 }));
            setRowCount(results.data1);
            setVisibleEmployees(withId);
            const p = withId[0];
            setPermissions({
                is_add: p?.is_add === "Yes" ? "Yes" : "No",
                is_update: p?.is_update === "Yes" ? "Yes" : "No",
                is_delete: p?.is_delete === "Yes" ? "Yes" : "No",
                is_download: p?.is_download === "Yes" ? "Yes" : "No",
                is_approve: p?.is_approve === "Yes" ? "Yes" : "No",
            });
        } catch {
            setPermissions({ is_add: "No", is_update: "No", is_delete: "No", is_download: "No", is_approve: "No" });
        } finally { setLoading(false); }
    };

    async function getAllUsers() {
        const results = await window.Platform.database.fetchEmployees();
        if (results?.status) { window.NotificationUtils.showError(results.message); return; }
        const admins = results?.data?.filter((u) => u?.role === "admin");
        setNewAllUsers(admins);
        setAllUsers(results?.data);
        setRsms(results?.data?.filter((e) => e.role.toLowerCase() === "rsm"));
        setRms(results?.data?.filter((e) => e.role.toLowerCase() === "se"));
        setAsms(results?.data?.filter((e) => e.role.toLowerCase() === "asm"));
    }

    // ── modulesPermissions builder (includes advanced keys) ──────────────────
    useEffect(() => {
        if (!newUser || !modules?.length) {
            setModulesPermissions(modules.map((m) => ({
                moduleId: m.moduleId,
                moduleName: m.moduleName,
                permissions: {
                    is_add: "No", is_update: "No", is_delete: "No", is_download: "No", is_approve: "No",
                    addSo: "No", verifySo: "No", disputeSo: "No",
                    // addInv: "No", verifyInv: "No", disputeInv: "No",
                    addSmInv: "No", addRcInv: "No",
                    verifySmInv: "No", verifyRcInv: "No",
                    disputeSmInv: "No", disputeRcInv: "No",
                    itemShipment: "No", updateShipment: "No", itemDeliver: "No",
                    verify: "No", onHold: "No",
                },
            })));
            return;
        }
        setModulesPermissions(modules.map((m) => {
            const ve = visibleEmployees?.find((row) =>
                row.moduleId === m.moduleId || row.module_id === m.moduleId ||
                row.module_name === m.moduleName || row.moduleName === m.moduleName
            );
            return {
                moduleId: m.moduleId,
                moduleName: m.moduleName,
                permissions: {
                    is_add: ve?.is_add === "Yes" ? "Yes" : "No",
                    is_update: ve?.is_update === "Yes" ? "Yes" : "No",
                    is_delete: ve?.is_delete === "Yes" ? "Yes" : "No",
                    is_download: ve?.is_download === "Yes" ? "Yes" : "No",
                    is_approve: ve?.is_approve === "Yes" ? "Yes" : "No",
                    addSo: ve?.addSo?.toLowerCase() === "yes" ? "Yes" : "No",
                    verifySo: ve?.verifySo?.toLowerCase() === "yes" ? "Yes" : "No",
                    disputeSo: ve?.disputeSo?.toLowerCase() === "yes" ? "Yes" : "No",
                    addSmInv: ve?.addSmInv?.toLowerCase() === "yes" ? "Yes" : "No",
                    addRcInv: ve?.addRcInv?.toLowerCase() === "yes" ? "Yes" : "No",
                    verifySmInv: ve?.verifySmInv?.toLowerCase() === "yes" ? "Yes" : "No",
                    verifyRcInv: ve?.verifyRcInv?.toLowerCase() === "yes" ? "Yes" : "No",
                    disputeSmInv: ve?.disputeSmInv?.toLowerCase() === "yes" ? "Yes" : "No",
                    disputeRcInv: ve?.disputeRcInv?.toLowerCase() === "yes" ? "Yes" : "No",
                    itemShipment: ve?.itemShipment?.toLowerCase() === "yes" ? "Yes" : "No",   // ← add
                    updateShipment: ve?.updateShipment?.toLowerCase() === "yes" ? "Yes" : "No", // ← add
                    itemDeliver: ve?.itemDeliver?.toLowerCase() === "yes" ? "Yes" : "No",
                    verify: ve?.verify?.toLowerCase() === "yes" ? "Yes" : "No",
                    onHold: ve?.onHold?.toLowerCase() === "yes" ? "Yes" : "No",
                },
            };
        }));
    }, [newUser, visibleEmployees, modules]);

    const toggleModulePermission = (moduleId, key) => {
        setModulesPermissions((prev) => prev.map((mp) =>
            mp.moduleId !== moduleId ? mp : {
                ...mp,
                permissions: { ...mp.permissions, [key]: mp.permissions[key] === "Yes" ? "No" : "Yes" },
            }
        ));
    };

    const handleSubmitModule = async (moduleId) => {
        setLoading(true);
        try {
            if (!newUser) { window.NotificationUtils.showError("Please select a user before submitting permissions"); return; }
            const mp = modulesPermissions.find((m) => m.moduleId === moduleId);
            if (!mp) { window.NotificationUtils.showError("Module not found"); return; }
            const payload = {
                moduleId: mp.moduleId,
                role,
                userId: newUser,
                permissions: mp.permissions,
            }

            const results = await window.Platform.database.createAccessModule(payload);
            if (results?.status) window.NotificationUtils.showError(results?.message || "Something went wrong");
            else window.NotificationUtils.showSuccess(results?.message || `Permissions submitted for ${mp.moduleName}`);
            fetchOrder();
        } catch { window.NotificationUtils.showError("Error submitting module permissions"); }
        finally { setLoading(false); }
    };

    // ── Advanced dialog save ─────────────────────────────────────────────────
    const handleSaveAdvanced = async () => {
        if (!newUser) { window.NotificationUtils.showError("Please select a user first"); return; }
        setAdvSaving(true);
        try {
            // merge advanced perms into the olympiad module permissions and submit
            const mp = modulesPermissions.find((m) => m.moduleId === OLYMPIAD_MODULE_ID);
            const mergedPermissions = { ...(mp?.permissions || {}), ...advPermissions };
            const payload = {
                moduleId: OLYMPIAD_MODULE_ID,
                role,
                userId: newUser,
                permissions: mergedPermissions,
            }
            const results = await window.Platform.database.createAccessModule(payload);

            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
            } else {
                window.NotificationUtils.showSuccess("Advanced Olympiad permissions saved successfully");
                setAdvDialogOpen(false);
                fetchOrder();
            }
        } catch { window.NotificationUtils.showError("Failed to save advanced permissions"); }
        finally { setAdvSaving(false); }
    };

    const toggleAdv = (key) => {
        setAdvPermissions((prev) => ({ ...prev, [key]: prev[key] === "Yes" ? "No" : "Yes" }));
    };

    // ── group advanced keys for display ──────────────────────────────────────
    const soGroup = ADVANCED_KEYS.filter((k) => k.key.toLowerCase().includes("so"));
    const invGroup = ADVANCED_KEYS.filter((k) => k.key.toLowerCase().includes("inv"));
    // ✅ No change needed here — the filter still works because all 6 new keys contain "inv"
    const shipGroup = ADVANCED_KEYS.filter((k) => ["itemShipment", "updateShipment", "itemDeliver"].includes(k.key));
    const verifyGroup = ADVANCED_KEYS.filter((k) => ["verify", "onHold"].includes(k.key));

    return (
        <>
            {loading && <OpaqueLoading />}
            <StaffEditorPageContainer>
                <HeaderContainer>
                    <Box sx={{ mt: 1, width: "100%" }}>
                        <div className="container-fluid">

                            {/* ── Filters ── */}
                            <div className="row mb-2">
                                <div className="col-md-4">
                                    <FormControl fullWidth>
                                        <InputLabel sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>Select Role</InputLabel>
                                        <Select label="Select Role" fullWidth sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}
                                            value={role} onChange={(e) => setRole(e.target.value)}>
                                            {roles.map((r) => (
                                                <MenuItem key={r.roleName} value={r.roleName} sx={{ fontWeight: "500", color: "black", fontSize: "14px" }}>
                                                    {r.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-4">
                                    <Autocomplete
                                        options={newAllUsers}
                                        getOptionLabel={(o) => o.name && o.username ? `${o.name} - ${o.username}` : o.name || o.username || ""}
                                        value={allUsers.find((u) => u.id === newUser) || null}
                                        onChange={(_, v) => setNewUser(v ? v.id : "")}
                                        renderInput={(params) => (
                                            <TextField label="Select User" {...params} placeholder="Select User"
                                                InputProps={{ ...params.InputProps, style: { color: "black", fontWeight: 500 } }}
                                                InputLabelProps={{ style: { color: "black", fontWeight: 500 } }}
                                            />
                                        )}
                                        slotProps={{ paper: { sx: { color: "black" } } }}
                                        isOptionEqualToValue={(o, v) => o.id === v.id}
                                        sx={{ width: "100%", fontSize: 14, color: "black" }}
                                    />
                                </div>

                                {/* ── Advanced Olympiad Actions button (top-right) ── */}
                                <div className="col-md-4 d-flex align-items-center justify-content-end">
                                    <Tooltip title={!newUser ? "Select a user first to manage advanced permissions" : "Manage Olympiad Registration action permissions"}>
                                        <span>
                                            <Button
                                                variant="contained"
                                                disabled={!newUser}
                                                onClick={() => setAdvDialogOpen(true)}
                                                startIcon={<TuneIcon />}
                                                sx={{
                                                    background: enabledAdvCount > 0
                                                        ? "linear-gradient(135deg, #1d4ed8, #7c3aed)"
                                                        : "linear-gradient(135deg, #374151, #6b7280)",
                                                    color: "#fff",
                                                    fontWeight: 600,
                                                    fontSize: "13px",
                                                    borderRadius: "10px",
                                                    textTransform: "none",
                                                    px: 2.5,
                                                    py: 1,
                                                    boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
                                                    "&:hover": { opacity: 0.92, boxShadow: "0 6px 18px rgba(0,0,0,0.2)" },
                                                    "&.Mui-disabled": { opacity: 0.45, color: "#fff" },
                                                }}
                                            >
                                                Advanced Olympiad Actions
                                                {enabledAdvCount > 0 && (
                                                    <Chip
                                                        label={`${enabledAdvCount} active`}
                                                        size="small"
                                                        sx={{
                                                            ml: 1, height: 20, fontSize: 10, fontWeight: 700,
                                                            backgroundColor: "#fbbf24", color: "#1f2937",
                                                            "& .MuiChip-label": { px: 0.8 },
                                                        }}
                                                    />
                                                )}
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>

                            {/* ── Permissions table ── */}
                            <div className="row mt-3">
                                <div className="col-12">
                                    <Paper sx={{ p: 2 }}>
                                        <div style={{ overflowX: "auto" }}>
                                            <table className="table table-striped table-bordered" style={{ minWidth: 800 }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ color: "#000", backgroundColor: "#fff" }}>Module</th>
                                                        <th style={{ textAlign: "center", color: "#000", backgroundColor: "#fff" }}>Add</th>
                                                        <th style={{ textAlign: "center", color: "#000", backgroundColor: "#fff" }}>Update</th>
                                                        <th style={{ textAlign: "center", color: "#000", backgroundColor: "#fff" }}>Delete</th>
                                                        <th style={{ textAlign: "center", color: "#000", backgroundColor: "#fff" }}>Download</th>
                                                        <th style={{ textAlign: "center", color: "#000", backgroundColor: "#fff" }}>Approve</th>
                                                        <th style={{ textAlign: "center", color: "#000", backgroundColor: "#fff" }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {modulesPermissions.map((m) => (
                                                        <tr key={m.moduleId}>
                                                            <td style={{ verticalAlign: "middle", fontWeight: 500 }}>
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                    {m.moduleName}
                                                                    {/* badge for olympiad module showing advanced status */}
                                                                    {m.moduleId === OLYMPIAD_MODULE_ID && enabledAdvCount > 0 && newUser && (
                                                                        <Chip
                                                                            label={`${enabledAdvCount} adv`}
                                                                            size="small"
                                                                            sx={{
                                                                                height: 18, fontSize: 10, fontWeight: 700,
                                                                                background: "linear-gradient(135deg,#1d4ed8,#7c3aed)",
                                                                                color: "#fff", "& .MuiChip-label": { px: 0.7 },
                                                                            }}
                                                                        />
                                                                    )}
                                                                </Box>
                                                            </td>
                                                            <td style={{ textAlign: "center" }}>
                                                                <Checkbox checked={m.permissions.is_add === "Yes"} onChange={() => toggleModulePermission(m.moduleId, "is_add")} />
                                                            </td>
                                                            <td style={{ textAlign: "center" }}>
                                                                <Checkbox checked={m.permissions.is_update === "Yes"} onChange={() => toggleModulePermission(m.moduleId, "is_update")} />
                                                            </td>
                                                            <td style={{ textAlign: "center" }}>
                                                                <Checkbox checked={m.permissions.is_delete === "Yes"} onChange={() => toggleModulePermission(m.moduleId, "is_delete")} />
                                                            </td>
                                                            <td style={{ textAlign: "center" }}>
                                                                <Checkbox checked={m.permissions.is_download === "Yes"} onChange={() => toggleModulePermission(m.moduleId, "is_download")} />
                                                            </td>
                                                            <td style={{ textAlign: "center" }}>
                                                                <Checkbox checked={m.permissions.is_approve === "Yes"} onChange={() => toggleModulePermission(m.moduleId, "is_approve")} />
                                                            </td>
                                                            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                <Button size="small" variant="contained" disabled={!newUser} onClick={() => handleSubmitModule(m.moduleId)}>
                                                                    Submit
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Paper>
                                </div>
                            </div>
                        </div>
                    </Box>
                </HeaderContainer>

                <TableContainer>
                    <TabsContainer>
                        {loading && <OpaqueLoading />}
                    </TabsContainer>
                </TableContainer>
            </StaffEditorPageContainer>

            {/* ════════════════════════════════════════════════════════════════
                Advanced Olympiad Actions Dialog
            ════════════════════════════════════════════════════════════════ */}
            <Dialog
                open={advDialogOpen}
                // onClose={() => setAdvDialogOpen(false)}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return;
                    setAdvDialogOpen(false);
                }}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: "16px",
                        overflow: "hidden",
                        boxShadow: "0 25px 60px rgba(0,0,0,0.18)",
                    }
                }}
            >
                {/* ── Dialog Header ── */}
                <DialogTitle sx={{ p: 0 }}>
                    <Box sx={{
                        background: "linear-gradient(135deg, #1e3a8a 0%, #4c1d95 100%)",
                        px: 3, py: 2.5,
                        display: "flex", justifyContent: "space-between", alignItems: "flex-start",
                    }}>
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                                <TuneIcon sx={{ color: "#93c5fd", fontSize: 20 }} />
                                <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 17 }}>
                                    Advanced Olympiad Actions
                                </Typography>
                            </Box>
                            {/* <Typography sx={{ color: "#93c5fd", fontSize: 12 }}>
                                Configure action-level permissions for Olympiad Registration module
                            </Typography> */}
                            {newUser && (
                                <Chip
                                    label={allUsers.find((u) => u.id === newUser)?.name || "Selected User"}
                                    size="small"
                                    sx={{ mt: 1, backgroundColor: "rgba(255,255,255,0.15)", color: "#e0f2fe", fontSize: 11, fontWeight: 600 }}
                                />
                            )}
                        </Box>
                        <IconButton onClick={() => setAdvDialogOpen(false)} sx={{ color: "#93c5fd", mt: -0.5 }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <DialogContent sx={{ px: 3, pt: 2.5, pb: 1 }}>

                    {/* ── Summary strip ── */}
                    <Box sx={{
                        display: "flex", alignItems: "center", justifyContent: "space-between",
                        backgroundColor: enabledAdvCount > 0 ? "#eff6ff" : "#f9fafb",
                        border: `1px solid ${enabledAdvCount > 0 ? "#bfdbfe" : "#e5e7eb"}`,
                        borderRadius: "10px", px: 2, py: 1.2, mb: 2,
                    }}>
                        <Typography sx={{ fontSize: 13, color: "#374151", fontWeight: 500 }}>
                            {enabledAdvCount === 0
                                ? "No advanced permissions enabled"
                                : `${enabledAdvCount} of ${ADVANCED_KEYS.length} permissions enabled`}
                        </Typography>
                        {enabledAdvCount > 0 && (
                            <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                                {ADVANCED_KEYS.filter((k) => advPermissions[k.key] === "Yes").map((k) => (
                                    <Chip key={k.key} label={k.label} size="small"
                                        sx={{ height: 20, fontSize: 10, fontWeight: 600, backgroundColor: "#dbeafe", color: "#1d4ed8" }} />
                                ))}
                            </Box>
                        )}
                    </Box>


                    {/* ── Verify & Hold group ── */}
                    <GroupLabel>Verify &amp; Hold Permissions</GroupLabel>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {verifyGroup.map(({ key, label, description, color }) => (
                            <ActionCard key={key} enabled={advPermissions[key] === "Yes" ? 1 : 0}
                                onClick={() => toggleAdv(key)}>
                                <Box sx={{
                                    width: 36, height: 36, borderRadius: "50%", flexShrink: 0,
                                    backgroundColor: advPermissions[key] === "Yes" ? `${color}20` : "#f3f4f6",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                }}>
                                    {advPermissions[key] === "Yes"
                                        ? <CheckCircleIcon sx={{ color, fontSize: 22 }} />
                                        : <RadioButtonUncheckedIcon sx={{ color: "#9ca3af", fontSize: 22 }} />
                                    }
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: 14, color: advPermissions[key] === "Yes" ? "#065f46" : "#111827" }}>
                                        {label}
                                    </Typography>
                                    <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{description}</Typography>
                                </Box>
                                <Checkbox
                                    checked={advPermissions[key] === "Yes"}
                                    onChange={() => toggleAdv(key)}
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{ color: "#d1d5db", "&.Mui-checked": { color } }}
                                />
                            </ActionCard>
                        ))}
                    </Box>

                    {/* ── Sales Order group ── */}
                    <GroupLabel>Sales Order Permissions</GroupLabel>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {soGroup.map(({ key, label, description, color }) => (
                            <ActionCard key={key} enabled={advPermissions[key] === "Yes" ? 1 : 0}
                                onClick={() => toggleAdv(key)}>
                                <Box sx={{
                                    width: 36, height: 36, borderRadius: "50%", flexShrink: 0,
                                    backgroundColor: advPermissions[key] === "Yes" ? `${color}20` : "#f3f4f6",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                }}>
                                    {advPermissions[key] === "Yes"
                                        ? <CheckCircleIcon sx={{ color, fontSize: 22 }} />
                                        : <RadioButtonUncheckedIcon sx={{ color: "#9ca3af", fontSize: 22 }} />
                                    }
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: 14, color: advPermissions[key] === "Yes" ? "#065f46" : "#111827" }}>
                                        {label}
                                    </Typography>
                                    <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{description}</Typography>
                                </Box>
                                <Checkbox
                                    checked={advPermissions[key] === "Yes"}
                                    onChange={() => toggleAdv(key)}
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{ color: "#d1d5db", "&.Mui-checked": { color } }}
                                />
                            </ActionCard>
                        ))}
                    </Box>

                    {/* ── Invoice group ── */}
                    <GroupLabel>Invoice Permissions</GroupLabel>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {invGroup.map(({ key, label, description, color }) => (
                            <ActionCard key={key} enabled={advPermissions[key] === "Yes" ? 1 : 0}
                                onClick={() => toggleAdv(key)}>
                                <Box sx={{
                                    width: 36, height: 36, borderRadius: "50%", flexShrink: 0,
                                    backgroundColor: advPermissions[key] === "Yes" ? `${color}20` : "#f3f4f6",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                }}>
                                    {advPermissions[key] === "Yes"
                                        ? <CheckCircleIcon sx={{ color, fontSize: 22 }} />
                                        : <RadioButtonUncheckedIcon sx={{ color: "#9ca3af", fontSize: 22 }} />
                                    }
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: 14, color: advPermissions[key] === "Yes" ? "#065f46" : "#111827" }}>
                                        {label}
                                    </Typography>
                                    <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{description}</Typography>
                                </Box>
                                <Checkbox
                                    checked={advPermissions[key] === "Yes"}
                                    onChange={() => toggleAdv(key)}
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{ color: "#d1d5db", "&.Mui-checked": { color } }}
                                />
                            </ActionCard>
                        ))}
                    </Box>

                    {/* ── Shipment group ── */}
                    <GroupLabel>Shipment Permissions</GroupLabel>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {shipGroup.map(({ key, label, description, color }) => (
                            <ActionCard key={key} enabled={advPermissions[key] === "Yes" ? 1 : 0}
                                onClick={() => toggleAdv(key)}>
                                <Box sx={{
                                    width: 36, height: 36, borderRadius: "50%", flexShrink: 0,
                                    backgroundColor: advPermissions[key] === "Yes" ? `${color}20` : "#f3f4f6",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                }}>
                                    {advPermissions[key] === "Yes"
                                        ? <CheckCircleIcon sx={{ color, fontSize: 22 }} />
                                        : <RadioButtonUncheckedIcon sx={{ color: "#9ca3af", fontSize: 22 }} />
                                    }
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: 14, color: advPermissions[key] === "Yes" ? "#065f46" : "#111827" }}>
                                        {label}
                                    </Typography>
                                    <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{description}</Typography>
                                </Box>
                                <Checkbox
                                    checked={advPermissions[key] === "Yes"}
                                    onChange={() => toggleAdv(key)}
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{ color: "#d1d5db", "&.Mui-checked": { color } }}
                                />
                            </ActionCard>
                        ))}
                    </Box>
                    <Box sx={{ height: 12 }} />
                </DialogContent>

                {/* ── Dialog Footer ── */}
                <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e5e7eb", gap: 1 }}>
                    <Button onClick={() => setAdvDialogOpen(false)}
                        sx={{ color: "#6b7280", fontWeight: 500, textTransform: "none" }}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        disabled={advSaving}
                        onClick={handleSaveAdvanced}
                        sx={{
                            background: "linear-gradient(135deg, #1d4ed8, #7c3aed)",
                            fontWeight: 600, textTransform: "none", borderRadius: "8px",
                            px: 3, "&:hover": { opacity: 0.9 },
                        }}
                    >
                        {advSaving ? "Saving…" : "Save Permissions"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}